import React from 'react';

import WrappedPasswordResetForm from 'components/HomePage/PasswordResetForm';
import authPageBg from 'assets/auth-page-bg.jpg';
import PageTitle from 'shared/PageTitle';

const PasswordReset = () => (
  <div>
    <PageTitle title="Forgot Password" />
    <div
      className="sign-in-page bg-dark-grey auth-page"
      style={{ backgroundImage: `url(${authPageBg})` }}
    >
      <div className="row no-margin justify-content-center align-items-center">
        <div className="col-md-5 col-lg-4 col-sm-10">
          <WrappedPasswordResetForm />
        </div>
      </div>
    </div>
  </div>
);

export default PasswordReset;



// WEBPACK FOOTER //
// ./src/components/HomePage/PasswordResetPage.js